<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />

    <div class="chapter-title">Указания по ведению журнала бурения скважин, разбуривания уширений в основании скважин или оболочек</div>
    <p>1. В журнал вносятся данные при выполнении работ по:</p>
    <p>2. бурению скважин, в том числе в основании оболочек;</p>
    <p>3. разбуриванию уширений в основании скважин или оболочек.</p>
    <p>4. Записи в журнале должны производиться непосредственно при производстве буровых работ. Ведение черновых записей на отдельных листах, тетрадях и т.п. воспрещается.</p>
    <p>5. В Графе «Примечание» указываются: причина и длительность задержек в производстве работ.</p>
    <p>6. В случае замены оборудования в журнале делаются соответствующие записи.</p>
    <p>7. В графе «Отметка для скважин» по окончании проходки указывается глубина шлама (поды) в случае наличия ее на дне скважины.</p>

    <n-items v-if="project">
      <n-input title="Представитель технического надзора" value="" />
      <n-input title="Представитель авторского надзора" value="" />
      <n-input title="Начальник участка (старший производитель работ)" value="" />
      <n-input title="Начальник производственно-технического отдела" value="" />
      <!--      <n-button @click="submit" color="success">Сохранить</n-button>-->
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter4',
  props: [ 'project', 'journal', ],
  data: () => ({
    data: [],
  }),
  computed: {
    columns() {
      if (!this.journal?.front) {
        return []
      } else {
        return [
          ...this.journal.front.index[2].content,
          { name: 'tools', title: '', },
        ]
      }
    },
    createRecordLink() {
      return { query: { ...this.$route.query, 'new-record': null, }, }
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journalsOld.records.get(this.project.id, this.$route.params.journal, 'records').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    &::v-deep {
      .n-table .row.header .cell {
        min-width: 100px;
      }
    }
  }
</style>
